import { Component, OnInit, Input, EventEmitter } from '@angular/core';
import { ApiService } from '../../../../api/api.service';
import { AssistanceProvider } from '../../../../models/assistance-provider';
import { AssistancePrice } from '../../../../models/assistance-price';
import { LoaderService } from '../../../../api/loader.service';


@Component({
    selector: 'app-assistance-provider-card',
    templateUrl: './assistance-provider-card.component.html',
    styleUrls: ['./assistance-provider-card.component.css'],
    standalone: false
})
export class AssistanceProviderCardComponent implements OnInit {
  provider: AssistanceProvider = null;
  prices: AssistancePrice = null;
  provider_site: any = null;
  coverage: any = null;
  users: any = null;
  @Input() provider_id: EventEmitter<number>;
  @Input() provider_site_id: EventEmitter<number>;
  @Input() coverage_id: EventEmitter<number>;
  @Input() service_id: EventEmitter<number>;
  @Input() case_id: number;
  sent_service_id: number = null;
  sent_provider_id: number = null;
  sent_provider_site_id: number = null;
  sent_coverage_id: number = null;

  country_event = new EventEmitter<number>();
  showReassignProviderDialog = false
  service = new EventEmitter<number>();
  providers_re = new EventEmitter<any>();
  
  constructor(  
    private LoaderService: LoaderService,
    
    private api: ApiService) { }

  
  ngOnInit() {

    this.provider_id.subscribe(provider_id =>{
      this.sent_provider_id = provider_id
      if(provider_id == null){
        this.resetVars()
      }
      if (this.sent_provider_id != null){
        // this.getProviderAndServiceInfo(this.sent_provider_id, this.sent_service_id);
      }
    })
    this.provider_site_id.subscribe(provider_site_id =>{
      this.sent_provider_site_id = provider_site_id
      if(provider_site_id == null){
        this.resetVars()
      }
      if (this.sent_provider_site_id != null){
        // this.getProviderAndServiceInfo(this.sent_provider_id, this.sent_service_id);
      }
    })
    this.coverage_id.subscribe(coverage_id =>{
      this.sent_coverage_id = coverage_id
      if(coverage_id == null){
        this.resetVars()
      }
      if (this.sent_coverage_id != null){
        // this.getProviderAndServiceInfo(this.sent_provider_id, this.sent_service_id);
      }
    })
    this.service_id.subscribe(service_id =>{
      this.sent_service_id = service_id
      if(service_id == null){
        this.resetVars()
      }
      if (this.sent_service_id != null){
        setTimeout(() => {
          this.getProviderAndServiceInfo(
            this.sent_provider_id,
            this.sent_provider_site_id,
            this.sent_coverage_id,
            this.sent_service_id
          );
        }, 100);
      }
    })

  }

  getProviderAndServiceInfo(provider_id, provider_site_id, coverage_id, service_id) {

    this.LoaderService.display(true)

    this.api.assistanceProvidersById.get(provider_id).promise().then(resp => {
      this.provider = resp
      // this.prices = resp["price"]
      // this.users = resp["users"]
      this.LoaderService.display(false)
    })
    .catch(e => {
      
      this.LoaderService.display(false)
    });

    this.api.assistanceProviders.getAssistanceProviderSiteItem(provider_id, provider_site_id).promise().then(resp2 => {
      this.provider_site = resp2.content[0];
      // this.prices = resp["price"]
      // this.users = resp["users"]
      this.LoaderService.display(false)
    })
    .catch(e => {
      
      this.LoaderService.display(false)
    });

    this.api.assistanceProviders.getAssistanceProviderCoverageItem(provider_site_id, coverage_id).promise().then(resp3 => {
      this.coverage = resp3.content[0];
      // this.prices = resp["price"]
      // this.users = resp["users"]
      this.LoaderService.display(false)
    })
    .catch(e => {
      
      this.LoaderService.display(false)
    });

    this.api.assistancePricesProvidersByIdservicesById.get(provider_id, provider_site_id, coverage_id, service_id).promise()
      .then(price => {
        this.prices = price;
        this.LoaderService.display(false)
      })
      .catch(e => {
        
        this.LoaderService.display(false)
      });

    // this.api.assistanceProviders.getServiceInfo(provider_id, service_id).promise().then(
    //   resp =>{
    //     this.provider = resp["provider"]
    //     this.prices = resp["price"]
    //     this.users = resp["users"]
    //     this.LoaderService.display(false)
    //   }
    // )
  }
  resetVars(){
    this.provider = null;
    this.prices = null;
    this.sent_provider_id = null;
    this.sent_service_id = null;
    this.users = null;
  }



  async ReassignProvider(servi:any){
    let providers_rea
    //this.country.emit(this.assistancecase.country.id)
    this.service.emit(servi)
    
    
    //
    const filter = {
      //country_id: this.assistancecase.country.id,
      service_id: servi,
      status: 1
    };
    this.showReassignProviderDialog = true
    // try{
    //   //  await ( this.api.assistanceProviders.getre().filter(filter).promise()
    //   await ( await this.api.assistance_case_providers.get(this.case_id, { "all": true }).promise()
    //   .then(res => {
    //     let data = res.data
    //     
    //     
    //     providers_rea = data;
    //     this.providers_re.emit(providers_rea)
    //  }))

    //  } catch(exception){
    //   
    //   
    // }
  }


}
